var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-powerrail" }),
        _vm._v(_vm._s(_vm.$t("Power Rails")) + " ")
      ]),
      _c(
        "v-row",
        { staticClass: "pa-0 ma-0 mt-4", attrs: { align: "center" } },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center pb-0",
              attrs: { cols: "12", md: "2" }
            },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "close-on-content-click": false,
                    "content-class": "columnMenu"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "manage-btn btn",
                                  attrs: { text: "", small: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Manage Columns")) + " "
                              ),
                              _c(
                                "v-icon",
                                {
                                  class: { rotate: _vm.menuOpen },
                                  attrs: { right: "" }
                                },
                                [_vm._v(" mdi-chevron-down ")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menuOpen,
                    callback: function($$v) {
                      _vm.menuOpen = $$v
                    },
                    expression: "menuOpen"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "column-card" },
                    [
                      _c("v-card-title", { staticClass: "column-header" }, [
                        _vm._v(" " + _vm._s(_vm.$t("Select Columns")) + " ")
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-list",
                        { staticClass: "select-all", attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value": _vm.isAllSelected,
                                  "hide-details": ""
                                },
                                on: { change: _vm.toggleSelectAll }
                              }),
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.$t("Select All")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "column-list" },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(
                              _vm.PowerRailInfoHeaders.filter(function(h) {
                                return (
                                  h.value !== "code" && h.value !== "action"
                                )
                              }),
                              function(header) {
                                return _c(
                                  "v-list-item",
                                  { key: header.value },
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        value: header.text,
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.visibleColumns,
                                        callback: function($$v) {
                                          _vm.visibleColumns = $$v
                                        },
                                        expression: "visibleColumns"
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "column-text" },
                                      [_vm._v(_vm._s(header.text))]
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-actions",
                        { staticClass: "column-footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                background: "#c57171",
                                color: "#ffffff !important",
                                width: "80px"
                              },
                              attrs: { color: "error", text: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { width: "80px" },
                              attrs: { color: "primary", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                  _vm.SaveVisibleColumns()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-none d-md-flex align-center justify-center pa-0",
              attrs: { cols: "1" }
            },
            [
              _c("v-divider", {
                staticStyle: { "min-height": "36px", "margin-top": "12px" },
                attrs: { vertical: "" }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center flex-wrap py-0 pr-search-row",
              attrs: { cols: "12", md: "9" }
            },
            [
              _c("v-select", {
                staticClass: "form-select pr-field",
                attrs: {
                  items: _vm.searchTypes,
                  label: _vm.$t("Search By"),
                  outlined: "",
                  dense: "",
                  "hide-details": ""
                },
                on: {
                  change: function($event) {
                    return _vm.InputReset()
                  }
                },
                model: {
                  value: _vm.search.type,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "type", $$v)
                  },
                  expression: "search.type"
                }
              }),
              _vm.search.type === "powerRail"
                ? _c("v-text-field", {
                    staticClass: "form-input pr-field",
                    attrs: {
                      label: _vm.$t("Power Rail ID"),
                      placeholder: _vm.$t("Power Rail ID"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.togetPowerRailList(1)
                      }
                    },
                    model: {
                      value: _vm.search.code,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "code", $$v)
                      },
                      expression: "search.code"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "powerRail"
                ? _c("v-select", {
                    staticClass: "form-select pr-field",
                    attrs: {
                      label: _vm.$t("Status"),
                      placeholder: _vm.$t("Select status"),
                      items: _vm.searchOptions.network,
                      "item-text": "text",
                      "item-value": "abbr",
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.search.state,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "state", $$v)
                      },
                      expression: "search.state"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "shelf"
                ? _c("v-text-field", {
                    staticClass: "form-input pr-field",
                    attrs: {
                      label: _vm.$t("Shelf ID"),
                      placeholder: _vm.$t("Shelf ID"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.togetPowerRailList(1)
                      }
                    },
                    model: {
                      value: _vm.search.shelfId,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "shelfId", $$v)
                      },
                      expression: "search.shelfId"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "shelf"
                ? _c("v-text-field", {
                    staticClass: "form-input pr-field",
                    attrs: {
                      label: _vm.$t("Shelf Floor"),
                      placeholder: _vm.$t("Shelf Floor"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.togetPowerRailList(1)
                      }
                    },
                    model: {
                      value: _vm.search.shelfFloor,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "shelfFloor", $$v)
                      },
                      expression: "search.shelfFloor"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "shelf"
                ? _c("v-text-field", {
                    staticClass: "form-input pr-field",
                    attrs: {
                      label: _vm.$t("Shelf Row"),
                      placeholder: _vm.$t("Shelf Row"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.togetPowerRailList(1)
                      }
                    },
                    model: {
                      value: _vm.search.shelfRow,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "shelfRow", $$v)
                      },
                      expression: "search.shelfRow"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "battery"
                ? _c("v-select", {
                    staticClass: "form-select pr-field",
                    attrs: {
                      label: _vm.$t("Battery"),
                      placeholder: _vm.$t("Select Battery status"),
                      items: _vm.searchOptionsBattery.options,
                      "item-text": "text",
                      "item-value": "abbr",
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.search.battery,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "battery", $$v)
                      },
                      expression: "search.battery"
                    }
                  })
                : _vm._e(),
              _vm.search.type === "signal"
                ? _c("v-select", {
                    staticClass: "form-select pr-field",
                    attrs: {
                      label: _vm.$t("Signal"),
                      placeholder: _vm.$t("Select Signal status"),
                      items: _vm.searchOptionsSignal.options,
                      "item-text": "text",
                      "item-value": "abbr",
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: ""
                    },
                    model: {
                      value: _vm.search.signal,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "signal", $$v)
                      },
                      expression: "search.signal"
                    }
                  })
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticClass: "btn type-search pr-btn",
                  staticStyle: { "padding-top": "25px !important" },
                  attrs: { text: "" },
                  on: {
                    click: function() {
                      this$1.selected = []
                      _vm.togetPowerRailList(1)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "col-12 pl-0 pb-0 pt-0 pr-0 d-flex",
          staticStyle: { "margin-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 pl-0" },
            [
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type01 mt-10",
                  attrs: {
                    headers: _vm.filteredPowerRailHeaders,
                    "hide-default-footer": true,
                    items: _vm.powerrails,
                    options: _vm.options,
                    "show-select": "",
                    "server-items-length": _vm.totalpowerrails,
                    "item-key": "code"
                  },
                  on: {
                    "update:options": function($event) {
                      _vm.options = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.assignedLabelCount",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("p", [
                              _c(
                                "i",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.GetLabelInfo(item)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/info-ico-custom.png"),
                                      alt: "",
                                      height: "25"
                                    }
                                  })
                                ]
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "item.status",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  top: "",
                                  "content-class": "tooltip-content"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b({}, "div", attrs, false),
                                              on
                                            ),
                                            [
                                              item.status !== "-"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-center"
                                                    },
                                                    [
                                                      _c("p", {
                                                        staticClass: "circle",
                                                        style:
                                                          item.status &&
                                                          item.status.toLowerCase() ===
                                                            "offline".toLowerCase()
                                                            ? "background-color: #e27070"
                                                            : "background-color: #9bcde3"
                                                      })
                                                    ]
                                                  )
                                                : _c("div", [
                                                    _vm._v(_vm._s(item.status))
                                                  ])
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t(item.status)))
                                ])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.shelfInfo",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            item.status !== "-"
                              ? _c(
                                  "div",
                                  { staticClass: "d-flex justify-center" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          top: "",
                                          "content-class": "tooltip-content"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.shelfId
                                                              ? item.shelfId
                                                              : "-"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("Shelf Id")))
                                        ])
                                      ]
                                    ),
                                    _c("div", { staticClass: "ml-1 mr-1" }, [
                                      _vm._v(_vm._s(" / "))
                                    ]),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          top: "",
                                          "content-class": "tooltip-content"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.shelfFloor
                                                              ? item.shelfFloor
                                                              : "-"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("Shelf Floor")))
                                        ])
                                      ]
                                    ),
                                    _c("div", { staticClass: "ml-1 mr-1" }, [
                                      _vm._v(_vm._s(" / "))
                                    ]),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: {
                                          top: "",
                                          "content-class": "tooltip-content"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "div",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.ShelfRow
                                                              ? item.ShelfRow
                                                              : "-"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.$t("Shelf Row")))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "item.action",
                        fn: function(ref) {
                          var item = ref.item
                          return [
                            _c("div", { staticClass: "d-flex" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "d-inline-block mr-2",
                                  class: {
                                    "disabled-pointer": [
                                      "UNASSIGNED",
                                      "UNASSIGNING"
                                    ].includes(item.state),
                                    pointer: ![
                                      "UNASSIGNED",
                                      "UNASSIGNING"
                                    ].includes(item.state)
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      !["UNASSIGNED", "UNASSIGNING"].includes(
                                        item.state
                                      ) && _vm.editDialogOpen(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "darken-2",
                                      style: {
                                        color: [
                                          "UNASSIGNED",
                                          "UNASSIGNING"
                                        ].includes(item.state)
                                          ? "#A0A0A0"
                                          : "#001e38"
                                      },
                                      attrs: { size: "24" }
                                    },
                                    [_vm._v(" mdi-square-edit-outline ")]
                                  )
                                ],
                                1
                              )
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: _vm.selected,
                    callback: function($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _c("PowerRailLabelDetailModel", {
        attrs: {
          powerRailCode: _vm.powerRailCode,
          ControllerID: _vm.ControllerID
        },
        model: {
          value: _vm.LabelDetailsPopup,
          callback: function($$v) {
            _vm.LabelDetailsPopup = $$v
          },
          expression: "LabelDetailsPopup"
        }
      }),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.selected.length !== 1 ||
                    _vm.isAssignUnassignDeleteDisabled,
                  text: ""
                },
                on: {
                  click: function($event) {
                    return _vm.assignPowerRailPopup()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Assign")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.selected.length === 0 ||
                    _vm.isAssignUnassignDeleteDisabled,
                  text: ""
                },
                on: {
                  click: function($event) {
                    return _vm.UnlinkPowerRail()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Unassign")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.selected.length === 0 ||
                    _vm.isAssignUnassignDeleteDisabled,
                  text: ""
                },
                on: {
                  click: function($event) {
                    return _vm.DeletePowerRail()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Delete")) + " ")]
            ),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.selected.length === 0 ||
                    _vm.isAssignUnassignDeleteDisabled,
                  text: ""
                },
                on: {
                  click: function($event) {
                    return _vm.ResetPowerRail()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Reset")) + " ")]
            )
          ],
          1
        )
      ]),
      _c("Pagination", {
        attrs: {
          pageInfoText: _vm.pageInfoText,
          pageIndex: _vm.pageIndex,
          rowPerPage: _vm.rowPerPage,
          goToPageInput: _vm.goToPageInput,
          totalPages: _vm.totalPages
        },
        on: {
          paging: function($event) {
            return _vm.paging($event)
          },
          updatePage: function($event) {
            return _vm.updatePage($event)
          }
        }
      }),
      _c("a", { ref: "link", style: { display: "none" } }),
      _c("msg-box", {
        attrs: { msgBox: _vm.msgBox },
        on: { closeMsgBox: _vm.closeMsgBox }
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", width: "450" },
          model: {
            value: _vm.assignPopup,
            callback: function($$v) {
              _vm.assignPopup = $$v
            },
            expression: "assignPopup"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "popup add_store_popup" },
            [
              _c("v-card-title", [
                _c("h3", { staticClass: "page-title-bar" }, [
                  _c("i", { staticClass: "ico ico-multi" }),
                  _vm._v(_vm._s(_vm.$t("ASSIGN")) + " ")
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    staticClass: "form-input mb-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      disabled: "",
                      placeholder: "" + _vm.$t("Input Power Rail ID"),
                      label: _vm.$t("Power Rail ID *")
                    },
                    model: {
                      value: _vm.assignPowerRailData.powerRailId,
                      callback: function($$v) {
                        _vm.$set(_vm.assignPowerRailData, "powerRailId", $$v)
                      },
                      expression: "assignPowerRailData.powerRailId"
                    }
                  }),
                  _c("v-text-field", {
                    staticClass: "form-input mb-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      placeholder: "" + _vm.$t("Input Shelf ID"),
                      label: _vm.$t("Shelf ID")
                    },
                    model: {
                      value: _vm.assignPowerRailData.shelfId,
                      callback: function($$v) {
                        _vm.$set(_vm.assignPowerRailData, "shelfId", $$v)
                      },
                      expression: "assignPowerRailData.shelfId"
                    }
                  }),
                  _c("v-text-field", {
                    staticClass: "form-input mb-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      placeholder: "" + _vm.$t("Input Shelf Floor"),
                      label: _vm.$t("Shelf Floor")
                    },
                    model: {
                      value: _vm.assignPowerRailData.shelfFloor,
                      callback: function($$v) {
                        _vm.$set(_vm.assignPowerRailData, "shelfFloor", $$v)
                      },
                      expression: "assignPowerRailData.shelfFloor"
                    }
                  }),
                  _c("v-text-field", {
                    staticClass: "form-input mb-2",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      placeholder: "" + _vm.$t("Input Shelf Row"),
                      label: _vm.$t("Shelf Row")
                    },
                    model: {
                      value: _vm.assignPowerRailData.shelfRow,
                      callback: function($$v) {
                        _vm.$set(_vm.assignPowerRailData, "shelfRow", $$v)
                      },
                      expression: "assignPowerRailData.shelfRow"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  !_vm.editPopup
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            text: "",
                            icon: "",
                            disabled:
                              _vm.assignPowerRailData.powerRailId === null ||
                              _vm.assignPowerRailData.powerRailId === ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.assignPowerRail()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Assign")) + " ")]
                      )
                    : _vm._e(),
                  _vm.editPopup
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "btn",
                          attrs: {
                            text: "",
                            icon: "",
                            disabled:
                              _vm.assignPowerRailData.powerRailId === null ||
                              _vm.assignPowerRailData.powerRailId === ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.UpdatePowerRail()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Update")) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.assignPopup = false
                          _vm.editPopup = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Cancel")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }